import React, { useState } from 'react';
import { useAdminAuth } from '../context/AdminAuthContext';
import Swal from 'sweetalert2';
import '../styles/AdminPages.css';

const AdminUsers = () => {
  const { admins, addAdmin, updateAdmin, deleteAdmin, isSuperAdmin } = useAdminAuth();
  const [showModal, setShowModal] = useState(false);
  const [editingAdmin, setEditingAdmin] = useState(null);
  const [formData, setFormData] = useState({ name: '', email: '', password: '' });
  const [error, setError] = useState('');

  if (!isSuperAdmin()) {
    return <div className="admin-page"><p>Access denied. Super admin only.</p></div>;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (editingAdmin) {
      const result = updateAdmin(editingAdmin.id, formData);
      if (!result.success) {
        setError(result.error);
        return;
      }
    } else {
      const result = addAdmin(formData);
      if (!result.success) {
        setError(result.error);
        return;
      }
    }

    setShowModal(false);
    setEditingAdmin(null);
    setFormData({ name: '', email: '', password: '' });
  };

  const handleEdit = (admin) => {
    setEditingAdmin(admin);
    setFormData({ name: admin.name, email: admin.email, password: '' });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'This admin will be permanently deleted!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc2626',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Yes, delete!',
      cancelButtonText: 'Cancel'
    });

    if (result.isConfirmed) {
      deleteAdmin(id);
      Swal.fire({
        title: 'Deleted!',
        text: 'Admin has been deleted.',
        icon: 'success',
        timer: 1500,
        showConfirmButton: false
      });
    }
  };

  const openAddModal = () => {
    setEditingAdmin(null);
    setFormData({ name: '', email: '', password: '' });
    setShowModal(true);
  };

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div>
          <h1>Admin Users</h1>
          <p>Manage admin accounts</p>
        </div>
        <button className="admin-btn primary" onClick={openAddModal}>
          + Add Admin
        </button>
      </div>

      <div className="admin-table-card">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Created At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr className="super-admin-row">
              <td>Super Admin</td>
              <td>admin@tannit.uk</td>
              <td><span className="admin-badge super">Super Admin</span></td>
              <td>-</td>
              <td>-</td>
            </tr>
            {admins.map((admin) => (
              <tr key={admin.id}>
                <td>{admin.name}</td>
                <td>{admin.email}</td>
                <td><span className="admin-badge">Admin</span></td>
                <td>{new Date(admin.createdAt).toLocaleDateString()}</td>
                <td>
                  <div className="admin-actions">
                    <button className="admin-btn-sm edit" onClick={() => handleEdit(admin)}>
                      Edit
                    </button>
                    <button className="admin-btn-sm delete" onClick={() => handleDelete(admin.id)}>
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))}
            {admins.length === 0 && (
              <tr>
                <td colSpan="5" className="admin-empty">No other admins added yet</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="admin-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
            <div className="admin-modal-header">
              <h2>{editingAdmin ? 'Edit Admin' : 'Add New Admin'}</h2>
              <button className="admin-modal-close" onClick={() => setShowModal(false)}>×</button>
            </div>
            <form onSubmit={handleSubmit}>
              {error && <div className="admin-form-error">{error}</div>}
              <div className="admin-form-group">
                <label>Name</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                />
              </div>
              <div className="admin-form-group">
                <label>Email</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                />
              </div>
              <div className="admin-form-group">
                <label>Password {editingAdmin && '(leave blank to keep current)'}</label>
                <input
                  type="password"
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  required={!editingAdmin}
                />
              </div>
              <div className="admin-modal-actions">
                <button type="button" className="admin-btn secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </button>
                <button type="submit" className="admin-btn primary">
                  {editingAdmin ? 'Update' : 'Create'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminUsers;
